import { D } from '@wave/shared';

/**
 * Дельта значения за окно: последняя точка минус ПЕРВАЯ точка, попадающая
 * в окно [now − windowMs, now]. Меньше двух точек в окне → null.
 * pct — в процентах от базы, null при нулевой базе. Всё на decimal.js.
 */
export function deltaOverWindow(
  points: { ts: string; value: string }[],
  windowMs: number,
  nowMs: number,
): { delta: string; pct: string | null } | null {
  const from = nowMs - windowMs;
  const inWindow = points.filter((p) => Date.parse(p.ts) >= from);
  if (inWindow.length < 2) return null;
  const base = D(inWindow[0]!.value);
  const last = D(inWindow[inWindow.length - 1]!.value);
  const delta = last.minus(base);
  const pct = base.isZero() ? null : delta.dividedBy(base.abs()).times(100).toDecimalPlaces(1).toString();
  return { delta: delta.toDecimalPlaces(2).toString(), pct };
}

/** Возраст последней точки серии в мс; null для пустой серии. */
export function lastPointAgeMs(points: { ts: string }[], nowMs: number): number | null {
  if (points.length === 0) return null;
  return nowMs - Date.parse(points[points.length - 1]!.ts);
}

/** «только что» / «N мин назад» / «N ч назад» / «N дн назад»; null → null. */
export function fmtAgo(iso: string | null, nowMs: number): string | null {
  if (iso === null) return null;
  const ageMs = nowMs - Date.parse(iso);
  if (ageMs < 60_000) return 'только что';
  const mins = Math.floor(ageMs / 60_000);
  if (mins < 60) return `${mins} мин назад`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} ч назад`;
  return `${Math.floor(hours / 24)} дн назад`;
}
